import React from 'react';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import './ReceptionStore.less';

import { usePackagingFlow } from '../../../context/PackagingFlowContext';

const ReceptionStore: React.FC = () => {
    const history = useHistory();
    const { reset } = usePackagingFlow();
    const receptionFromOrganization = () => {
        reset();
        history.push(`/delivery-info`);
    };
    const receptionFromDirectSupplier = () => {
        reset();
        history.push(`/receptionFromSupplier`);
    };

    return (
        <div className="reception-type-page">
            <div className="title">
                <h2>Veuillez choisir le type de réception</h2>
            </div>
            <Button className="reception-button" block onClick={receptionFromOrganization}>
                Expédiée par la SCA
            </Button>
            <Button className="reception-button" block onClick={receptionFromDirectSupplier}>
                Expédiée par un fournisseur
            </Button>
        </div>
    );
};

export default ReceptionStore;
